/**
 * Mutable drag state shared across bridge modules.
 * Registrations live on window so HMR cannot wipe moveHandler / dragContextRef.
 */

const registrations = window.__fokusM2SRegistrations
  || (window.__fokusM2SRegistrations = { moveHandler: null, dragContextRef: null });

let state = createEmptyState();
/** Last valid drop target while pointer was over the sidebar (survives mouseup jitter). */
let lockedDropTargetSprintId = null;

export function createEmptyState() {
  return {
    active: false,
    taskId: null,
    sourceSprintId: null,
    taskName: null,
    source: null,
    hoverTargetSprintId: null,
    isOverSidebar: false,
    taskIcon: null,
    lastPointer: null,
    /** Full task captured at drag start — survives stale global sprints[] metadata. */
    sourceTask: null,
    sourceNodePositions: null,
    /** Set when dragging a nested-campaign container node (the campaign it links to). */
    nestedSprintId: null,
  };
}

export function getRawState() {
  return state;
}

export function setRawState(nextState) {
  state = nextState;
}

export function getLockedDropTargetSprintId() {
  return lockedDropTargetSprintId;
}

export function setLockedDropTargetSprintId(id) {
  lockedDropTargetSprintId = id;
}

export function getRegistrations() {
  return registrations;
}

export function buildPublicState() {
  const lockedTarget = lockedDropTargetSprintId;
  const showDragGhost = state.active && !!state.lastPointer
    && (state.isOverSidebar || !!state.hoverTargetSprintId || !!lockedTarget);
  return {
    active: state.active,
    taskId: state.taskId,
    sourceSprintId: state.sourceSprintId,
    taskName: state.taskName,
    source: state.source,
    hoverTargetSprintId: state.hoverTargetSprintId,
    isOverSidebar: state.isOverSidebar,
    taskIcon: state.taskIcon,
    lastPointer: state.lastPointer,
    sourceTask: state.sourceTask,
    sourceNodePositions: state.sourceNodePositions,
    nestedSprintId: state.nestedSprintId,
    lockedDropTargetSprintId: lockedTarget,
    showDragGhost,
  };
}

export function isDragActive() {
  return state.active;
}

export function hasHoverTarget() {
  return state.active && !!state.hoverTargetSprintId;
}

export function isOverSidebar() {
  return state.active && state.isOverSidebar;
}
